<template>
  <div class="home">
    <!--顶部-->
    <div v-if="merchant === 'salesman'">
      <van-loading
        class="home-loadings"
        v-show="shows"
        type="spinner"
        color="#1989fa"
      />
      <div v-if="!shows">
        <div class="home-van-cell">
          <div class="home-van-cell__title">
            <span>我的头像</span>
          </div>
          <div class="home-van-cell__value">
            <div class="head_img" @click.stop="uploadHeadImg">
              <img :src="avatar" />
            </div>
            <input
              type="file"
              accept="image/*"
              @change="handleFile"
              ref="hiddenInput"
              class="hiddenInput"
            />
          </div>
        </div>
        <p class="home-perspmal-boundary"></p>
        <div class="home-perspmal-van-cell">
          <div class="home-perspmal-van-cell__title">
            <span>我的昵称</span>
          </div>
          <div class="home-perspmal-van-cell__value">
            <van-field
              @click="$refs.nickname.focus()"
              ref="nickname"
              v-model="nickname"
              input-align="right"
              :placeholder="nickname"
            />
          </div>
        </div>
        <p class="home-perspmal-boundary"></p>
        <div class="home-perspmal-phone">
          <div class="home-perspmal-van-phone">
            <span>我的手机号</span>
          </div>
          <div class="home-perspmal-van-phoneright">
            <span>{{ phone }}</span>

            <!-- <span @click="show=true">修改</span> -->
          </div>
          <van-popup v-model="show">
            <div class="home-perspmal-amend">
              <div class="home-perspamal-amend-one">
                <span>修改手机号</span>
                <img
                  @click="show = false"
                  src="../../assets/image/close.jpg"
                  alt
                />
              </div>
              <div class="home-perspamal-amend-tow">
                <van-cell-group class="home-congratulation-from">
                  <van-field
                    type="tel"
                    @click="$refs.phone.focus()"
                    ref="phone"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"
                    keyboardType="UIKeyboardTypeDecimalPad;"
                    v-model="phone2"
                    maxlength="11"
                    placeholder="请输入手机号"
                  />
                  <div>
                    <van-field
                      type="tel"
                      @click="$refs.verifycode.focus()"
                      ref="verifycode"
                      style="width:8.59375rem"
                      onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"
                      keyboardType="UIKeyboardTypeDecimalPad;"
                      v-model="verifycode"
                      maxlength="6"
                      center
                      clearable
                      placeholder="请输入验证码"
                    />
                    <van-button
                      color="#2480FF"
                      class="home-congratulation-from-button"
                      style="width:7.59375rem"
                      @click="sendVerifycode()"
                      type="primary"
                      round
                      :disabled="!disabledCodeBtn"
                      >{{ codeText }}</van-button
                    >
                  </div>
                  <div>
                    <van-button
                      color="#2480FF"
                      slot="button"
                      type="primary"
                      round
                      block
                      @click="login()"
                      native-type="submit"
                      >确定</van-button
                    >
                  </div>
                </van-cell-group>
              </div>
            </div>
          </van-popup>
        </div>
        <p class="home-perspmal-boundary"></p>
        <div v-if="isBusiness">
          <div class="home-perspmal-phone">
            <div class="home-perspmal-van-phone">
              <span>店铺小票机</span>
            </div>
            <div class="home-perspmal-van-phoneright">
              <span @click="goTicket">去设置</span>
            </div>
          </div>
          <p class="home-perspmal-boundary"></p>
        </div>
      </div>
    </div>
    <div v-if="merchant === 'merchant'">
      <van-loading
        class="home-loadings"
        v-show="shows"
        type="spinner"
        color="#1989fa"
      />
      <van-form>
        <div class="home-perspmal-van-cell">
          <div class="home-perspmal-van-cell__title">
            <span>商家名称</span>
          </div>
          <div class="home-perspmal-van-cell__value">
            <van-field
              @click="$refs.end.focus()"
              ref="end"
              v-model="merchantval.end"
              input-align="right"
              placeholder="请输入商家名称"
            />
          </div>
        </div>
        <p class="home-perspmal-boundary"></p>
        <div class="home-perspmal-van-cell">
          <div class="home-perspmal-van-cell__title">
            <span>联系人</span>
          </div>
          <div class="home-perspmal-van-cell__value">
            <van-field
              @click="$refs.name.focus()"
              ref="name"
              v-model="merchantval.name"
              input-align="right"
              placeholder="请输入联系人姓名"
            />
          </div>
        </div>
        <p class="home-perspmal-boundary"></p>
        <div class="home-perspmal-van-cell">
          <div class="home-perspmal-van-cell__title">
            <span>联系电话</span>
          </div>
          <div class="home-perspmal-van-cell__value">
            <van-field
              @click="$refs.name.focus()"
              ref="pohop"
              v-model="merchantval.pohop"
              input-align="right"
              placeholder="请输入联系人电话"
            />
          </div>
        </div>
        <p class="home-perspmal-boundary"></p>
        <div class="home-perspmal-van-cell">
          <div class="home-perspmal-van-cell__title">
            <span>地区</span>
          </div>
          <div class="home-perspmal-van-cell__value">
            <van-field
              readonly
              clickable
              name="area"
              :value="merchantval.carmodel"
              placeholder="点击选择省市区"
              @click="showArea = true"
            />
            <van-popup v-model="showArea" position="bottom">
              <van-area
                :area-list="areaList"
                @confirm="onConfirms"
                @cancel="showArea = false"
              />
            </van-popup>
          </div>
        </div>
        <p class="home-perspmal-boundary"></p>
        <div class="home-perspmal-van-cell">
          <div class="home-perspmal-van-cell__title">
            <span>地区</span>
          </div>
          <div class="home-perspmal-van-cell__value">
            <van-field
              @click="$refs.ditas.focus()"
              ref="ditas"
              v-model="merchantval.ditas"
              input-align="right"
              placeholder="请输入详细地址"
            />
          </div>
        </div>
        <p class="home-perspmal-boundary"></p>
      </van-form>
    </div>
    <div class="home-cell__value-buttom">
      <van-button @click="save" round type="primary">保存</van-button>
    </div>
  </div>
</template>

<script>
import areaList from "../../config/area";
// import {
//   updateUserInfo,
//   personInfo,
//   businessCenter
// } from "../../api/Personal/Personal";
import { request } from "@/utils/https";
import { Toast } from "vant";
import moment from "moment";
import getUpToken from "@/api/getUpToken";
import axios from "axios";
import { getUserToken } from "@/utils/Cookie";
export default {
  name: "personal",
  data() {
    return {
      phone2: "",
      avatar: "",
      shows: false,
      types: "",
      phone: "",
      verifycode: "",
      nickname: "", //昵称
      codeText: "获取验证码",
      disabledCodeBtn: true,
      userInfo: {
        avatar: require("../../assets/image/222.png"),
      },
      // merchant: "merchant", //商家
      merchant: "salesman", // 业务员
      show: false,
      showArea: false,
      merchantval: {
        end: "", //商家名称
        name: "", //请输入联系人姓名
        pohop: "", //请输入联系人电话
        titas: "", //请输入详细地址
        carmodel: "", //地址
      },
      areaList,
    };
  },
  computed: {
    isBusiness() {
      return this.$route.query.level == "商家";
    },
  },
  methods: {
    goTicket() {
      this.$router.push({
        path: "/ticket",
      });
    },
    async login() {
      if (this.verifyPhone()) {
        Toast(this.verifyPhone());
      } else if (this.verifycode == "") {
        Toast("请输入验证码");
      } else {
        let list = {
          phone: this.phone2,
          code: this.verifycode,
        };
        let res = await request("user/sms/verificationSmsCode", list);
        if (res.error == 0) {
          this.phone = this.phone2;
        }
      }
    },
    async personInfos() {
      if (this.merchant == "salesman") {
        let res = await request(
          "user/person/personInfo?token=" + getUserToken()
        );
        // console.log(res, "个人设置");
        if (res.data) {
          this.shows = false;
          this.avatar = res.data.avatar;
          this.nickname = res.data.nickname;
          this.phone = res.data.phone;
        }
        // personInfo().then(res => {
        //   console.log(res, "个人设置");

        //   if (res.data) {
        //     this.shows = false;
        //     this.avatar = res.data.avatar;
        //     this.nickname = res.data.nickname;
        //     this.phone = res.data.phone;
        //   }
        // });
      } else if (this.merchant == "merchant") {
        let res = await request(
          "user/business/businessCenter?token=" + getUserToken()
        );
        // console.log(res, "商家设置 ");
        if (res.data) {
          this.shows = false;
          this.merchantval = res.data;
        }
        // businessCenter().then(res => {
        //   console.log(res, "商家设置 ");
        //   if (res.data) {
        //     this.shows = false;
        //     this.merchantval = res.data;
        //   }
        // });
      }
    },
    async save() {
      if (this.merchant == "salesman") {
        let data = {
          avatar: this.avatar,
          nickname: this.nickname,
          phone: this.phone,
        };
        console.log(data);
        let res = await request(
          "user/test/updateUserInfo?token=" + getUserToken(),
          data
        );
        console.log(res);
        if (res.error == 0) {
          Toast("修改成功");
          this.$router.push({
            path: "promotion",
          });
        } else {
          Toast(res.error_reason + "修改失败");
        }
        // updateUserInfo(data).then(res => {
        //   if (res.error == 0) {
        //     Toast("修改成功");
        //   } else {
        //     Toast(res.error_reason + "修改失败");
        //   }
        // });
      } else if (this.merchant == "merchant") {
        // console.log(111);
      }
    },
    onConfirms(values) {
      this.merchantval.carmodel = values.map((item) => item.name).join("/");
      this.showArea = false;
    },
    funcs() {
      this.$router.back();
    },
    // 向后台要验证码方法
    async sendVerifycode() {
      if (this.verifyPhone()) {
        Toast(this.verifyPhone());
      } else {
        let data = {
          phone: this.phone2,
          type: "2",
        };
        let res = await request("user/sms/sendSms", data);
        if (res.error == 0) {
          this.countDown(60);
        } else {
          Toast(res.error_reason);
        }
        // sendSms(data).then(res => {
        //   if (res) {
        //     this.countDown(60);
        //   }
        // });
        //  用手机号向后台换取验证码，发送成功则开始调用倒计时分方法
      }
    },
    // 表单校验方法
    verifyPhone() {
      if (!this.phone) {
        return "请输入手机号";
      } else if (this.phone.length !== 11) {
        return "请输入11位手机号";
      } else {
        return false;
      }
    },
    // 倒计时方法
    countDown(time) {
      if (time === 0) {
        this.disabledCodeBtn = true;
        this.codeText = "获取验证码";
        return;
      } else {
        this.disabledCodeBtn = false;
        this.codeText = "重新发送(" + time + ")";
        time--;
      }
      setTimeout(() => {
        this.countDown(time);
      }, 1000);
    },
    uploadHeadImg: function() {
      this.$refs.hiddenInput.click();
    },
    // 将头像显示
    handleFile: function(e) {
      let $target = e.target || e.srcElement;
      console.log($target);
      let file = $target.files[0];

      var reader = new FileReader();
      reader.onload = (data) => {
        let res = data.target || data.srcElement;
        this.avatar = res.result;
      };
      return new Promise((resolve, reject) => {
        Toast("上传中...");

        let splitArray = file.name.split(".");
        let current = moment()
            .format("YYYYMMDD")
            .toString(),
          prefix = moment(file.lastModified)
            .format("HHmmss")
            .toString(),
          suffix =
            new Date().getTime() + "." + splitArray[splitArray.length - 1],
          key = encodeURI(`${current}/${prefix}_${suffix}`);
        getUpToken({ key })
          .then((res) => {
            let data = new FormData();
            data.append("token", res.data.uptoken);
            data.append("key", key);
            data.append("file", file);
            axios({
              url: "//upload.qiniup.com",
              method: "POST",
              data: data,
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }).then((res) => {
              Toast("上传成功...");
              // console.log(res, "图片呀");
              this.avatar = res.data.domain + res.data.truekey + "?imageslim";
              console.log(this.avatar);
            });
          })
          .catch((error) => {
            // console.log(error);
            Toast("上传成功");
            reject(error);
          });
      });
      // reader.readAsDataURL(file);
      // console.log(file);
    },
  },
  mounted() {
    // if (this.$route.query.types) {
    //   if (this.$route.query.types == "商家") {
    //     this.merchant = "merchant";
    //   } else {
    //     this.merchant = "salesman";
    //   }
    // }
    this.personInfos();
  },
};
</script>
<style lang="scss" scoped>
* {
  touch-action: none;
}

.home {
  width: 100%;
  background: rgba(246, 247, 249, 1);
  .home-perspmal-amend {
    padding: 0.9375rem 0.875rem 1.875rem 2.3125rem;
    .home-perspamal-amend-one {
      text-align: center;
      padding-bottom: 1.25rem;
      span {
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
      }
      img {
        width: 0.71875rem;
        height: 0.71875rem;
        float: right;
        // margin-left: 6.03125rem;
      }
    }
    .home-perspamal-amend-tow {
      padding-right: 1.4375rem;
      /deep/.van-field__control {
        text-align: left;
      }
      .home-congratulation-from {
        .van-cell {
          height: 2.8125rem;
          padding-bottom: 0.6rem;
          background: rgba(242, 242, 242, 1);
          border-radius: 45px;
        }
        div:nth-child(2) {
          margin-top: 0.75rem;
          display: flex;
          justify-content: center;
          .van-cell {
            margin: 0;
          }
          .van-field__body {
            margin-top: 0.46875rem;
          }

          .home-congratulation-from-button {
            margin-left: 0.75rem;
            width: 13.8125rem;
            height: 2.8125rem;
            background: rgba(36, 128, 255, 1);
            border-radius: 1.40625rem;
            font-size: 1rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);

            .van-button__content {
              margin-top: 0;
            }
          }
        }
        div:nth-child(3) {
          margin-top: 0.75rem;
        }
      }
    }
  }
  .home-van-cell {
    background-color: #fff;
    overflow: hidden;
    padding: 1.25rem 0.6875rem 1.25rem 0.703125rem;
    .home-van-cell__title {
      float: left;
      padding-top: 1.34375rem;
      span {
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
      }
    }
    .home-van-cell__value {
      float: right;
      img {
        width: 4.0625rem;
        height: 4.0625rem;
        border-radius: 50%;
      }
      .hiddenInput {
        display: none;
      }
    }
  }
  .home-perspmal-van-cell {
    overflow: hidden;
    background-color: #fff;

    padding: 1.25rem 0.6875rem 1.25rem 0.6875rem;

    .home-perspmal-van-cell__title {
      float: left;
      span {
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
      }
    }
    .home-perspmal-van-cell__value {
      float: right;
      .van-cell::after {
        border-bottom: 0px;
      }
      .van-cell {
        padding: 0;
      }
      input {
        border: 0;
      }
      span {
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(198, 198, 198, 1);
      }
    }
  }
  .home-perspmal-phone {
    overflow: hidden;
    background: #fff;
    padding: 1.25rem 0.75rem 1.25rem 0.703125rem;
    .home-perspmal-van-phone {
      float: left;
      span {
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
      }
    }
    .home-perspmal-van-phoneright {
      float: right;
      position: relative;
      span:first-child {
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
      input {
        width: 165%;
        position: absolute;
        right: 4rem;
      }
      span:last-child {
        padding-left: 1.25rem;
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(41, 114, 255, 1);
        float: right;
      }
    }
  }
}
/deep/.van-field__control {
  text-align: right;
}
</style>
